export const AppPermissionKeys = {
  // ==================== Super User ====================
  // System Error Log
  view_system_error_log: "view_system_error_log",

  // Operator Log
  view_operator_log: "view_operator_log",

  // Member Log
  view_member_log: "view_member_log",

  // System Maintenance
  view_system_maintenance: "view_system_maintenance",
  create_system_maintenance: "create_system_maintenance",
  edit_system_maintenance: "edit_system_maintenance",

  // Site Domain
  view_site_domain: "view_site_domain",
  create_site_domain: "create_site_domain",
  edit_site_domain: "edit_site_domain",

  // Audit Log
  view_audit_log: "view_audit_log",

  // API Key Settings
  view_api_key_settings: "view_api_key_settings",
  create_api_key: "create_api_key",
  edit_api_key: "edit_api_key",

  // Domain URLs
  view_domain_url: "view_domain_url",
  edit_domain_url: "edit_domain_url",

  // ==================== dashboard ====================
  view_graph: "view_graph",
  view_statistic_summary: "view_statistic_summary",
  dashboard_create_game_provider_maintenance_hour: "dashboard_create_game_provider_maintenance_hour",
  dashboard_view_game_provider_maintenance_hour: "dashboard_view_game_provider_maintenance_hour",

  // ==================== members ====================
  // all members
  view_member_list: "view_member_list",
  all_members_view_member_dialog: "all_members_view_member_dialog",
  create_new_member: "create_new_member",
  edit_member_details_restricted: "edit_member_details_restricted",
  edit_member_details: "edit_member_details",
  reset_password: "reset_password",
  update_member_status: "update_member_status",
  all_members_adjust_wallet: "all_members_adjust_wallet",
  all_members_assign_rewards: "all_members_assign_rewards",
  shadow_login: "shadow_login",
  force_logout: "force_logout",
  all_members_check_promotion_eligibility: "all_members_check_promotion_eligibility",
  export_member_list: "export_member_list",
  create_dummy_account: "create_dummy_account",
  edit_dummy_account: "edit_dummy_account",
  reset_deposit_attempts: 'reset_deposit_attempts',
  update_deposit_whitelist: 'update_deposit_whitelist',

  // Label and Remarks: Member Info - sub section
  view_member_info_list: "view_member_info_list",
  member_label_view_member_dialog: "member_label_view_member_dialog",
  create_member_label: "create_member_label",
  edit_member_label: "edit_member_label",

  // Label and Remarks: Label Settings - sub section
  view_label_settings_list: "view_label_settings_list",
  create_label_settings: "create_label_settings",
  edit_label_settings: "edit_label_settings",

  // member groups
  view_member_group_list: "view_member_group_list",
  create_new_member_group: "create_new_member_group",
  edit_member_group: "edit_member_group",
  view_deposit_limits: "view_deposit_limits",
  edit_deposit_limits: "edit_deposit_limits",
  view_withdrawal_limits: "view_withdrawal_limits",
  edit_withdrawal_limits: "edit_withdrawal_limits",
  view_bet_limit: "view_bet_limit",
  edit_bet_limit: "edit_bet_limit",

  // member verification
  view_member_verification_list: "view_member_verification_list",
  edit_member_verification: "edit_member_verification",
  view_verification_remark_history: "view_verification_remark_history",
  member_verification_view_member_dialog: "member_verification_view_member_dialog",

  // verification settings
  view_verification_settings_list: "view_verification_settings_list",
  create_verification_settings: "create_verification_settings",
  edit_verification_settings: "edit_verification_settings",
  duplicate_verification_settings: "duplicate_verification_settings",
  update_verification_setting_status: "update_verification_setting_status",

  // member online
  view_member_online_list: "view_member_online_list",
  member_online_view_member_dialog: "member_online_view_member_dialog",

  // member trace
  view_member_trace_list: "view_member_trace_list",
  export_member_trace_list: "export_member_trace_list",

  // pwa members (AIO-81798)
  view_pwa_member_list: "view_pwa_member_list",

  // bet limit (AIO-81599)
  view_sport_bet_limit_group_list: "view_sport_bet_limit_group_list",
  create_sport_bet_limit_group: "create_sport_bet_limit_group",
  edit_sport_bet_limit_group: "edit_sport_bet_limit_group",
  delete_sport_bet_limit_group: "delete_sport_bet_limit_group",
  export_sport_bet_limit_group_list: "export_sport_bet_limit_group_list",

  // referral
  view_referrals_list: "view_referrals_list",
  referrals_view_member_dialog: "referrals_view_member_dialog",
  export_referrals_list: "export_referrals_list",

  // ==================== Member Info Dialog ====================
  /// basic info
  view_member_info: "view_member_info",
  view_member_statistics: "view_member_statistics",

  /// wallet info
  view_wallet_info: "view_wallet_info",
  create_game_account: "create_game_account",
  sync_game_wallet_balance: "sync_game_wallet_balance",
  wallet_info_reset_password: "wallet_info_reset_password",
  reset_game_account: "reset_game_account",

  /// wallet event
  view_wallet_events: "view_wallet_events",

  /// history messages
  view_history_messages: "view_history_messages",
  view_sms_messages: "view_sms_messages",
  view_in_app_message: "view_in_app_message",
  view_web_push_message: "view_web_push_message",

  /// login events
  view_login_events: "view_login_events",

  /// bonus hunter analysis
  view_bonus_hunter_analysis: "view_bonus_hunter_analysis",
  view_general_analysis: "view_general_analysis",
  view_member_analysis: "view_member_analysis",

  /// member bank accountS
  view_member_bank_accounts: "view_member_bank_accounts",
  create_member_bank_account: "create_member_bank_account",
  update_bank_account_status: "update_bank_account_status",
  edit_member_bank_account: "edit_member_bank_account",
  view_member_crypto_accounts: "view_member_crypto_accounts",
  create_member_crypto_account: "create_member_crypto_account",
  update_bank_crypto_status: "update_bank_crypto_status",
  edit_member_crypto_account: "edit_member_crypto_account",
  view_verification_details: "view_verification_details",
  edit_verification_details: "edit_verification_details",
  reupload_verification_document: "reupload_verification_document",

  /// promotion history
  view_promotion_history: "view_promotion_history",
  view_promotion_history_log: "view_promotion_history_log",

  // ==================== Transactions ====================
  // deposits - banking
  view_banking_deposits: "view_banking_deposits",
  view_banking_deposits_member_dialog: "view_banking_deposits_member_dialog",
  create_deposit: "create_deposit",
  view_deposit_details: "view_deposit_details",
  edit_deposits: "edit_deposits",
  void_deposits_bank_transactions: "void_deposits_bank_transactions",
  void_deposits_payment_gateway: "void_deposits_payment_gateway",
  revert_deposits: "revert_deposits",
  resolve_unusual_callback_deposit: "resolve_unusual_callback_deposit",
  request_receipts: "request_receipts",
  upload_receipts: "upload_receipts",
  browse_receipts: "browse_receipts",
  view_deposit_receipts: "view_deposit_receipts",
  export_deposit_list: "export_deposit_list",
  view_deposit_event_history: "view_deposit_event_history",
  force_approve_deposits: "force_approve_deposits",
  manual_resolve_deposit_transaction: "manual_resolve_deposit_transaction",

  // deposits - banking
  view_crypto_deposits: "view_crypto_deposits",
  view_crypto_deposits_member_dialog: "view_crypto_deposits_member_dialog",
  view_crypto_deposit_details: "view_crypto_deposit_details",
  edit_crypto_deposits: "edit_crypto_deposits",
  void_crypto_deposits: "void_crypto_deposits",
  export_crypto_deposit_list: "export_crypto_deposit_list",
  bypass_banking_deposit_limit: "bypass_banking_deposit_limit",

  // withdrawals - banking
  view_banking_withdrawals: "view_banking_withdrawals",
  view_banking_withdrawal_amount: "view_banking_withdrawal_amount",
  transaction_withdrawals_banking_view_member_dialog: "transaction_withdrawals_banking_view_member_dialog",
  create_withdrawals: "create_withdrawals",
  view_withdrawal_details: "view_withdrawal_details",
  edit_withdrawals: "edit_withdrawals",
  upload_withdrawal_receipt: "upload_withdrawal_receipt",
  resolve_unusual_callback_withdrawal: "resolve_unusual_callback_withdrawal",
  sync_payout_transaction: "sync_payout_transaction",
  void_payout_transaction_bank_transfer: "void_payout_transaction_bank_transfer",
  void_payout_transaction_offline_bank: "void_payout_transaction_offline_bank", // AIO-79217
  void_payout_transaction_pg: "void_payout_transaction_pg",
  revert_payout_transaction: "revert_payout_transaction",
  process_risky_withdrawals: "process_risky_withdrawals",
  export_withdrawals_list: "export_withdrawals_list",
  force_approve_payout_transaction: "force_approve_payout_transaction",
  // AIO-78767 — resolve a payout stuck PENDING with no gateway callback. Approving a REJECTED payout
  // without a success callback is gated by force_approve_payout_transaction instead.
  manual_resolve_payout_transaction: "manual_resolve_payout_transaction",

  // Withdrawals - crypto
  view_crypto_withdrawals: "view_crypto_withdrawals",
  view_crypto_withdrawal_amount: "view_crypto_withdrawal_amount",
  transaction_withdrawals_crypto_view_member_dialog: "transaction_withdrawals_crypto_view_member_dialog",
  create_crypto_withdrawals: "create_crypto_withdrawals",
  view_crypto_withdrawal_details: "view_crypto_withdrawal_details",
  edit_crypto_withdrawals: "edit_crypto_withdrawals",
  void_crypto_withdrawals: "void_crypto_withdrawals",
  process_risky_crypto_withdrawals: "process_risky_crypto_withdrawals",
  export_crypto_withdrawals_list: "export_crypto_withdrawals_list",
  bypass_banking_withdrawal_limit: "bypass_banking_withdrawal_limit",
  view_withdrawal_event_history: "view_withdrawal_event_history",

  // transfers
  view_transfers_list: "view_transfers_list",
  transaction_transfers_view_member_dialog: "transaction_transfers_view_member_dialog",
  create_transfer: "create_transfer",
  approve_transfers: "approve_transfers",
  reject_transfers: "reject_transfers",
  refund_transfers: "refund_transfers",
  retry_transfers: "retry_transfers",
  check_transfer_status: "check_transfer_status",
  mark_as_failed: "mark_as_failed",
  export_transfers_list: "export_transfers_list",

  // transactions
  view_transactions_list: "view_transactions_list",
  transaction_transaction_view_member_dialog: "transaction_transaction_view_member_dialog",
  adjust_wallet: "adjust_wallet",
  export_transactions_list: "export_transactions_list",

  // ==================== Message Center ====================
  // all messages
  view_all_messages: "view_all_messages",
  all_messages_view_member_dialog: "all_messages_view_member_dialog",
  send_messages: "send_messages",
  export_all_messages: "export_all_messages",

  // all smses
  view_all_smses: "view_all_smses",
  all_smses_view_member_dialog: "all_smses_view_member_dialog",
  export_all_smses: "export_all_smses",

  // web push messages
  view_web_push_messages_list: "view_web_push_messages_list",
  web_push_messages_view_member_dialog: "web_push_messages_view_member_dialog",
  export_web_push_messages_list: "export_web_push_messages_list",

  // send inbox message
  send_message: "send_message",
  view_send_message: "view_send_message",
  view_send_message_histories: "view_send_message_histories",
  send_message_now: "send_message_now",
  view_message_settings: "view_message_settings",
  update_message_settings: "update_message_settings",
  cancel_scheduled_message: "cancel_scheduled_message",
  send_message_download_sent_report: "send_message_download_sent_report",

  // send sms
  send_sms: "send_sms",
  view_send_sms_histories: "view_send_sms_histories",
  send_sms_now: "send_sms_now",
  view_sms_settings: "view_sms_settings",
  update_sms_settings: "update_sms_settings",
  cancel_scheduled_sms: "cancel_scheduled_sms",
  send_sms_download_sent_report: "send_sms_download_sent_report",

  // send campaign sms
  send_campaign_sms: "send_campaign_sms",

  // send webpush
  send_webpush: "send_webpush",

  // sms provider
  view_sms_providers: "view_sms_providers",
  edit_sms_providers: "edit_sms_providers",

  // credentials
  view_credentials: "view_credentials",
  edit_credential: "edit_credential",

  // sms provider permissions
  view_sms_provider_permissions: "view_sms_provider_permissions",
  edit_vendor: "edit_vendor",
  update_sms_provider_status: "update_sms_provider_status",

  // SMS Provider settings (smsedge)
  view_provider_settings: "view_provider_settings",
  edit_provider_settings: "edit_provider_settings",

  // message template
  view_message_template_list: "view_message_template_list",
  create_message_template: "create_message_template",
  view_message_template: "view_message_template",
  edit_message_template: "edit_message_template",
  duplicate_message_template: "duplicate_message_template",

  // affiliate message template
  view_affiliate_message_template_list: "view_affiliate_message_template_list",
  view_affiliate_message_template: "view_affiliate_message_template",
  approve_affiliate_message_template: "approve_affiliate_message_template",
  reject_affiliate_message_template: "reject_affiliate_message_template",

  // ==================== Promotions ====================
  // member promotions
  view_member_promotions_list: "view_member_promotions_list",
  member_promotions_view_member_dialog: "member_promotions_view_member_dialog",
  cancel_member_promotions: "cancel_member_promotions",
  unlock_member_promotions: "unlock_member_promotions",
  sync_promotion_turnover: "sync_promotion_turnover",
  member_promotions_view_promotion_history_log: "member_promotions_view_promotion_history_log",
  export_member_promotions_list: "export_member_promotions_list",

  // promotion code
  view_promotion_codes_list: "view_promotion_codes_list",
  create_promotion_code: "create_promotion_code",
  view_promotion_code: "view_promotion_code",
  edit_promotion_code: "edit_promotion_code",
  bypass_promotion_turnover: "bypass_promotion_turnover",
  view_promotion_currency: "view_promotion_currency",
  add_promotion_currency: "add_promotion_currency",
  edit_promotion_currency: "edit_promotion_currency",
  view_promotion_name: "view_promotion_name",
  add_promotion_name: "add_promotion_name",
  edit_promotion_name: "edit_promotion_name",
  view_promotion_gp_blacklist: "view_promotion_gp_blacklist",
  view_promotion_gp_blacklist_template: "view_promotion_gp_blacklist_template",
  add_promotion_gp_blacklist_template: "add_promotion_gp_blacklist_template",
  edit_promotion_gp_blacklist_template: "edit_promotion_gp_blacklist_template",
  duplicate_promotion_gp_blacklist_template: "duplicate_promotion_gp_blacklist_template",
  view_game_provider_blacklist: "view_game_provider_blacklist",
  edit_game_provider_blacklist: "edit_game_provider_blacklist",
  duplicate_promotion_code: "duplicate_promotion_code",
  promotion_codes_check_member_eligibility: "promotion_codes_check_member_eligibility",
  export_promotion_codes_list: "export_promotion_codes_list",
  delete_promotion_code: "delete_promotion_code",
  view_archived_promotion_codes_list: "view_archived_promotion_codes_list",
  restore_promotion_code: "restore_promotion_code",

  // promotion contents
  view_promotion_contents_list: "view_promotion_contents_list",
  create_promotion_content: "create_promotion_content",
  edit_promotion_content: "edit_promotion_content",
  view_total_applicants_list: "view_total_applicants_list",
  promotion_contents_approve_reject_promotion_application: "promotion_contents_approve_reject_promotion_application",
  promotion_contents_check_member_eligibility: "promotion_contents_check_member_eligibility",

  // promotion content category
  view_promotion_content_category_list: "view_promotion_content_category_list",
  create_promotion_content_category: "create_promotion_content_category",
  edit_promotion_content_category: "edit_promotion_content_category",

  // recovery promotion
  view_recovery_promotion_list: "view_recovery_promotion_list",
  create_recovery_promotion: "create_recovery_promotion",
  edit_recovery_promotion: "edit_recovery_promotion",
  duplicate_recovery_promotion: "duplicate_recovery_promotion",
  update_recovery_promotion_status: "update_recovery_promotion_status",

  // promotion statistics
  view_promotion_statistics: "view_promotion_statistics",
  export_promotion_statistics: "export_promotion_statistics",

  // rewards
  view_rewards_list: "view_rewards_list",
  rewards_view_member_dialog: "rewards_view_member_dialog",
  assign_rewards: "assign_rewards",
  edit_reward: "edit_reward",
  import_member_rewards: "import_member_rewards",
  export_rewards_list: "export_rewards_list",
  check_promotion_eligibility: "check_promotion_eligibility",
  claim_member_reward_restricted: "claim_member_reward_restricted",
  claim_member_reward_unrestricted: "claim_member_reward_unrestricted",

  // referral settings
  view_referral_settings_list: "view_referral_settings_list",
  create_referral_settings: "create_referral_settings",
  edit_referral_settings: "edit_referral_settings",

  // lucky draw settings
  // Daily Check-In (AIO-80387)
  view_daily_checkin_list: "view_daily_checkin_list",
  edit_daily_checkin_settings: "edit_daily_checkin_settings",
  create_daily_checkin_set: "create_daily_checkin_set",
  edit_daily_checkin_set: "edit_daily_checkin_set",
  delete_daily_checkin_set: "delete_daily_checkin_set",

  view_lucky_draw_settings_list: "view_lucky_draw_settings_list",
  create_lucky_draw_settings: "create_lucky_draw_settings",
  view_lucky_draw_settings: "view_lucky_draw_settings",
  edit_lucky_draw_settings: "edit_lucky_draw_settings",
  create_rewards_settings: "create_rewards_settings",
  edit_rewards_settings: "edit_rewards_settings",
  remove_rewards_settings: "remove_rewards_settings",

  // promotion applications
  view_promotion_applications_list: "view_promotion_applications_list",
  promotion_applications_view_member_dialog: "promotion_applications_view_member_dialog",
  approve_reject_promotion_application: "approve_reject_promotion_application",
  export_promotion_application: "export_promotion_application",

  // ==================== Rebates ====================
  // rebates release
  view_rebate_releases_list: "view_rebate_releases_list",
  rebate_releases_view_member_dialog: "rebate_releases_view_member_dialog",
  generate_rebates: "generate_rebates",
  release_rebates: "release_rebates",
  reject_rebates: "reject_rebates",

  // rebates release 2.0
  view_rebate_releases_list_v2: "view_rebate_releases_list_v2",
  rebate_releases_view_member_dialog_v2: "rebate_releases_view_member_dialog_v2",
  generate_rebates_v2: "generate_rebates_v2",
  release_rebates_v2: "release_rebates_v2",
  reject_rebates_v2: "reject_rebates_v2",
  update_rebates_setting: "update_rebates_setting",
  view_rebate_details_v2: "view_rebate_details_v2",
  view_member_bet_logs_rebate_v2: "view_member_bet_logs_rebate_v2",
  view_game_report_rebate_v2: "view_game_report_rebate_v2",

  // Rebate History
  view_rebate_history: "view_rebate_history",

  // Rebate Settings
  view_rebate_settings_list: "view_rebate_settings_list",
  create_rebate_settings: "create_rebate_settings",
  view_rebate_settings: "view_rebate_settings",
  edit_rebate_settings: "edit_rebate_settings",
  rebate_settings_view_gp_blacklist: "rebate_settings_view_gp_blacklist",
  rebate_settings_view_gp_blacklist_template: "rebate_settings_view_gp_blacklist_template",
  rebate_settings_add_gp_blacklist_template: "rebate_settings_add_gp_blacklist_template",
  rebate_settings_edit_gp_blacklist_template: "rebate_settings_edit_gp_blacklist_template",
  rebate_settings_duplicate_gp_blacklist_template: "rebate_settings_duplicate_gp_blacklist_template",
  rebate_settings_view_game_provider_blacklist: "rebate_settings_view_game_provider_blacklist",
  rebate_settings_update_game_provider_blacklist: "rebate_settings_update_game_provider_blacklist",

  // ==================== Bank/Payment ====================
  // Merchant Banks -> Bank / Payment Gateway
  view_bank_payment_gateway_list: "view_bank_payment_gateway_list",
  create_merchant_bank: "create_merchant_bank",
  edit_merchant_bank: "edit_merchant_bank",
  update_merchant_bank_status: "update_merchant_bank_status",

  // Merchant Banks -> Crypto
  view_crypto_merchant_account_list: "view_crypto_merchant_account_list",
  create_crypto_merchant_bank: "create_crypto_merchant_bank",
  edit_crypto_merchant_account: "edit_crypto_merchant_account",
  update_crypto_merchant_accounts_status: "update_crypto_merchant_accounts_status",

  // Bank Transactions
  view_bank_transactions: "view_bank_transactions",
  create_bank_transaction: "create_bank_transaction",
  update_bank_transaction_status: "update_bank_transaction_status",
  view_receipts: "view_receipts",
  export_bank_transactions: "export_bank_transactions",

  // Bank Receipts
  view_bank_receipts_list: "view_bank_receipts_list",
  create_bank_receipt: "create_bank_receipt",
  edit_bank_receipt: "edit_bank_receipt",
  mark_receipt_as_used_read_only: "mark_receipt_as_used_read_only",
  reject_receipts: "reject_receipts",

  // Bank Bots
  view_bank_bots_list: "view_bank_bots_list",
  enter_bank_bot_tac: "enter_bank_bot_tac",
  update_bank_bot_status: "update_bank_bot_status",
  update_bank_bot_server: "update_bank_bot_server",
  update_bank_bot_mode: "update_bank_bot_mode",
  create_reconciliation_job: "create_reconciliation_job",

  // Payment Gateway Bank Bots
  view_payment_gateway_bots_list: "view_payment_gateway_bots_list",
  update_payment_gateway_bot_status: "update_payment_gateway_bot_status",
  create_payment_gateway_bot_reconciliation_job: "create_payment_gateway_bot_reconciliation_job",

  // Transaction Recon
  view_transaction_recon: "view_transaction_recon",
  export_transaction_recon: "export_transaction_recon",

  // Bank Settings
  view_bank_settings_list: "view_bank_settings_list",
  create_bank_settings: "create_bank_settings",
  update_bank_settings: "update_bank_settings",
  edit_bank_settings_maintenance_hours: "edit_bank_settings_maintenance_hours",

  // Payment Mode
  view_payment_mode_list: "view_payment_mode_list",
  create_payment_mode: "create_payment_mode",
  update_payment_mode: "update_payment_mode",
  edit_payment_mode_position: "edit_payment_mode_position",

  // ================== Agent ===================
  view_agents_list: "view_agents_list",
  view_agent_reports: "view_agent_reports",
  view_all_agent_reports: "view_all_agent_reports",

  // ==================== CMS Settings ====================
  view_marquee_list: "view_marquee_list",
  create_new_marquee: "create_new_marquee",
  view_marquee_details: "view_marquee_details",
  edit_marquee: "edit_marquee",
  update_marquee_status: "update_marquee_status",

  // Announcements -> Dialog
  view_dialog_list: "view_dialog_list",
  create_new_dialog: "create_new_dialog",
  view_dialog_details: "view_dialog_details",
  edit_dialog: "edit_dialog",
  duplicate_dialog: "duplicate_dialog",
  update_dialog_status: "update_dialog_status",
  preview_dialog: "preview_dialog",
  import_dialog_popup_logs: "import_dialog_popup_logs",

  // Banners
  view_banners_list: "view_banners_list",
  create_new_banner: "create_new_banner",
  view_banner_details: "view_banner_details",
  edit_banner: "edit_banner",
  update_banner_status: "update_banner_status",

  // Contacts -> JS Plugins -> Live Chat Script
  view_live_chat_script_list: "view_live_chat_script_list",
  create_live_chat_script: "create_live_chat_script",
  view_live_chat_script_details: "view_live_chat_script_details",
  edit_live_chat_script: "edit_live_chat_script",
  update_live_chat_script_status: "update_live_chat_script_status",

  // Contacts -> JS Plugins -> Mini Game
  view_mini_game_list: 'view_mini_game_list',
  mini_game_create_mini_game: 'mini_game_create_mini_game',
  view_mini_game_details: 'view_mini_game_details',
  mini_game_edit_mini_game: 'mini_game_edit_mini_game',
  update_mini_game_status: 'update_mini_game_status',

  // Contacts -> Contact Settings
  view_contacts_list: "view_contacts_list",
  create_new_contact: "create_new_contact",
  view_contact_details: "view_contact_details",
  edit_contact: "edit_contact",
  update_contact_status: "update_contact_status",

  // T&C
  view_tac_list: "view_tac_list",
  create_tac: "create_tac",
  view_tac_details: "view_tac_details",
  edit_tac: "edit_tac",
  update_tac_status: "update_tac_status",

  // FAQ
  view_faq_list: "view_faq_list",
  create_faq_section: "create_faq_section",
  create_faq: "create_faq",
  view_faq_details: "view_faq_details",
  edit_faq: "edit_faq",
  update_faq_status: "update_faq_status",

  // About Us
  view_about_us_list: "view_about_us_list",
  create_about_us: "create_about_us",
  view_about_us_details: "view_about_us_details",
  edit_about_us: "edit_about_us",
  update_about_us_status: "update_about_us_status",

  // privacy policy
  view_privacy_policy_list: "view_privacy_policy_list",
  create_privacy_policy: "create_privacy_policy",
  view_privacy_policy_details: "view_privacy_policy_details",
  edit_privacy_policy: "edit_privacy_policy",
  update_privacy_policy_status: "update_privacy_policy_status",

  // responsible gaming
  view_responsible_gaming_list: "view_responsible_gaming_list",
  create_responsible_gaming: "create_responsible_gaming",
  view_responsible_gaming_details: "view_responsible_gaming_details",
  edit_responsible_gaming: "edit_responsible_gaming",
  update_responsible_gaming_status: "update_responsible_gaming_status",

  // referral contents
  view_referral_content_list: "view_referral_content_list",
  view_referral_content_details: "view_referral_content_details",
  edit_referral_content: "edit_referral_content",

  // menu bar
  view_menu_bar_list: "view_menu_bar_list",
  create_menu_bar: "create_menu_bar",
  view_menu_bar_details: "view_menu_bar_details",
  edit_menu_bar: "edit_menu_bar",
  update_menu_bar_status: "update_menu_bar_status",
  view_logo_favicon_list: "view_logo_favicon_list",
  update_default_logo_favicon: "update_default_logo_favicon",
  create_logo_favicon: "create_logo_favicon",
  view_logo_favicon_details: "view_logo_favicon_details",
  edit_logo_favicon: "edit_logo_favicon",
  update_logo_favicon_status: "update_logo_favicon_status",

  // Website Display
  view_website_display_list: "view_website_display_list",
  edit_website_display_position: "edit_website_display_position",
  view_website_display_settings: "view_website_display_settings",
  edit_website_display_settings: "edit_website_display_settings",
  update_website_display_status: "update_website_display_status",

  // Footer settings -> Mobile Display
  view_mobile_display_list: "view_mobile_display_list",
  edit_mobile_display_position: "edit_mobile_display_position",
  view_mobile_display_settings: "view_mobile_display_settings",
  edit_mobile_display_settings: "edit_mobile_display_settings",
  update_mobile_display_status: "update_mobile_display_status",

  // Section Settings -> footer section
  view_footer_section_list: "view_footer_section_list",
  create_footer_section: "create_footer_section",
  view_footer_section_details: "view_footer_section_details",
  edit_footer_section: "edit_footer_section",

  // section settings - icon library
  view_icon_library_list: "view_icon_library_list",
  create_icon: "create_icon",
  edit_icon: "edit_icon",

  // section settings - quick link
  view_quick_link_list: "view_quick_link_list",
  create_quick_link: "create_quick_link",
  view_quick_link_details: "view_quick_link_details",
  edit_quick_link: "edit_quick_link",

  // Partnership
  view_partnership: "view_partnership",
  edit_partnership_setting: "edit_partnership_setting",
  create_partnership_section: "create_partnership_section",
  edit_partnership_section: "edit_partnership_section",
  delete_partnership_section: "delete_partnership_section",
  create_partnership_brand: "create_partnership_brand",
  edit_partnership_brand: "edit_partnership_brand",
  delete_partnership_brand: "delete_partnership_brand",

  // Registration Page
  view_registration_page_list: "view_registration_page_list",
  create_registration_page: "create_registration_page",
  view_registration_page_details: "view_registration_page_details",
  edit_registration_page: "edit_registration_page",
  duplicate_registration_page: "duplicate_registration_page",
  update_registration_page_status: "update_registration_page_status",

  // SEO Settings
  view_seo_settings_list: "view_seo_settings_list",
  create_seo_settings: "create_seo_settings",
  edit_seo_settings: "edit_seo_settings",
  view_route_settings: "view_route_settings",
  add_route: "add_route",
  edit_route: "edit_route",
  delete_route: "delete_route",
  view_meta_tag_settings: "view_meta_tag_settings",
  edit_meta_tag_settings: "edit_meta_tag_settings",
  duplicate_meta_tag_settings: "duplicate_meta_tag_settings",

  // ==================== VIP ====================
  // All VIPs
  view_all_vips_list: "view_all_vips_list",
  vip_view_member_dialog: "vip_view_member_dialog",
  create_vip: "create_vip",
  edit_vip: "edit_vip",
  approve_vip_upgrade: "approve_vip_upgrade",
  reject_vip_upgrade: "reject_vip_upgrade",
  export_all_vips_list: "export_all_vips_list",
  import_vip: "import_vip",

  // VIP Settings
  view_vip_settings_list: "view_vip_settings_list",
  create_vip_settings: "create_vip_settings",
  edit_vip_settings: "edit_vip_settings",

  // VIP Member Logs
  view_vip_member_logs_list: "view_vip_member_logs_list",
  vip_member_logs_view_member_dialog: "vip_member_logs_view_member_dialog",
  export_vip_member_logs: "export_vip_member_logs",

  // VIP Content Settings
  view_vip_structure_section: "view_vip_structure_section",
  view_vip_structure_details: "view_vip_structure_details",
  create_vip_structure: "create_vip_structure",
  edit_vip_structure_details: "edit_vip_structure_details",
  view_vip_content_settings_list: "view_vip_content_settings_list",
  view_vip_content_settings: "view_vip_content_settings",
  create_vip_content_settings: "create_vip_content_settings",
  edit_vip_content_settings: "edit_vip_content_settings",
  update_vip_content_status: "update_vip_content_status",

  // VIP Footer Settings
  view_vip_footer_section: "view_vip_footer_section",
  view_vip_footer_section_details: "view_vip_footer_section_details",
  create_vip_footer_section: "create_vip_footer_section",
  edit_vip_footer_section_details: "edit_vip_footer_section_details",
  view_vip_footer_content_list: "view_vip_footer_content_list",
  view_vip_footer_content_settings: "view_vip_footer_content_settings",
  create_vip_footer_content_settings: "create_vip_footer_content_settings",
  edit_vip_footer_content_settings: "edit_vip_footer_content_settings",
  update_vip_footer_content_status: "update_vip_footer_content_status",

  // ==================== Affiliates ====================
  // Affiliates Approvals
  view_affiliates_approvals_list: "view_affiliates_approvals_list",
  affiliates_approvals_view_affiliate_dialog: "affiliates_approvals_view_affiliate_dialog",
  affiliates_approvals_view_affiliate_settings: "affiliates_approvals_view_affiliate_settings",
  affiliates_approvals_edit_affiliate_settings: "affiliates_approvals_edit_affiliate_settings",
  approve_affiliate_application: "approve_affiliate_application",
  reject_affiliate_application: "reject_affiliate_application",

  // All Affiliates
  view_all_affiliates_list: "view_all_affiliates_list",
  all_affiliates_view_affiliate_dialog: "all_affiliates_view_affiliate_dialog",
  view_sub_affiliates: "view_sub_affiliates",
  view_member_registration: "view_member_registration",
  create_affiliate: "create_affiliate",
  edit_affiliate: "edit_affiliate",
  affiliate_postback_test_fire: "affiliate_postback_test_fire",
  suspend_affiliate: "suspend_affiliate",
  change_password: "change_password",
  adjust_group: "adjust_group",
  shadow_login_affiliate: "shadow_login_affiliate",
  view_test_fire_history: "view_test_fire_history",
  export_test_fire_history: "export_test_fire_history",

  // Affiliate Groups
  view_affiliate_groups_list: "view_affiliate_groups_list",
  create_affiliate_group: "create_affiliate_group",
  view_settings: "view_settings",
  commission_settings: "commission_settings",
  currency_settings: "currency_settings",
  settlement_settings: "settlement_settings",

  // Affiliate Group Settings (sub)
  view_affiliate_group_settings: "view_affiliate_group_settings",
  edit_affiliate_group_settings: "edit_affiliate_group_settings",

  // Affiliate Referral Settings (sub)
  view_affiliate_referral_settings: "view_affiliate_referral_settings",
  edit_affiliate_referral_settings: "edit_affiliate_referral_settings",

  // Affiliate Promotion Settings (sub)
  view_affiliate_promotion_settings: "view_affiliate_promotion_settings",
  edit_affiliate_promotion_settings: "edit_affiliate_promotion_settings",
  bulk_add_affiliate_promotion_eligibility: "bulk_add_affiliate_promotion_eligibility",
  add_affiliate_promotion_eligibility: "add_affiliate_promotion_eligibility",
  delete_affiliate_promotion_eligibility: "delete_affiliate_promotion_eligibility",

  // Affiliate Dialog Popup Settings (sub)
  view_affiliate_dialog_popup_settings: "view_affiliate_dialog_popup_settings",
  edit_affiliate_dialog_popup_settings: "edit_affiliate_dialog_popup_settings",
  bulk_add_affiliate_dialog_popup_eligibility: "bulk_add_affiliate_dialog_popup_eligibility",
  add_affiliate_dialog_popup_eligibility: "add_affiliate_dialog_popup_eligibility",
  delete_affiliate_dialog_popup_eligibility: "delete_affiliate_dialog_popup_eligibility",

  // Affiliate Inbox Message Settings (sub)
  view_affiliate_inbox_message_settings: "view_affiliate_inbox_message_settings",
  edit_affiliate_inbox_message_settings: "edit_affiliate_inbox_message_settings",
  bulk_add_affiliate_inbox_message_eligibility: "bulk_add_affiliate_inbox_message_eligibility",
  add_affiliate_inbox_message_eligibility: "add_affiliate_inbox_message_eligibility",
  delete_affiliate_inbox_message_eligibility: "delete_affiliate_inbox_message_eligibility",

  // Affiliate Member Group Settings (sub)
  view_affiliate_member_group_settings: "view_affiliate_member_group_settings",
  edit_affiliate_member_group_settings: "edit_affiliate_member_group_settings",
  bulk_add_affiliate_member_group_eligibility: "bulk_add_affiliate_member_group_eligibility",
  add_affiliate_member_group_eligibility: "add_affiliate_member_group_eligibility",
  delete_affiliate_member_group_eligibility: "delete_affiliate_member_group_eligibility",

  // Commission Releases
  view_commission_releases_list: "view_commission_releases_list",
  commission_releases_view_affiliate_dialog: "commission_releases_view_affiliate_dialog",
  generate_affiliate_commission: "generate_affiliate_commission",
  release_affiliate_commission: "release_affiliate_commission",
  reject_affiliate_commission: "reject_affiliate_commission",
  export_affiliate_commission: "export_affiliate_commission",

  // Affiliate Deposits
  view_affiliate_deposits_list: "view_affiliate_deposits_list",
  affiliate_deposits_view_affiliate_dialog: "affiliate_deposits_view_affiliate_dialog",
  view_affiliate_deposit_details: "view_affiliate_deposit_details",
  edit_affiliate_deposits: "edit_affiliate_deposits",
  affiliate_deposits_view_receipt: "affiliate_deposits_view_receipt",

  // Affiliate Withdrawals
  view_affiliate_withdrawals_list: "view_affiliate_withdrawals_list",
  affiliate_withdrawals_view_affiliate_dialog: "affiliate_withdrawals_view_affiliate_dialog",
  view_affiliate_withdrawal_details: "view_affiliate_withdrawal_details",
  edit_affiliate_withdrawal: "edit_affiliate_withdrawal",

  // Affiliate Transfer
  view_affiliate_transfer_list: "view_affiliate_transfer_list",
  affiliate_transfer_view_affiliate_dialog: "affiliate_transfer_view_affiliate_dialog",

  // Affiliate Adjustments
  view_affiliate_adjustments_list: "view_affiliate_adjustments_list",
  affiliate_adjustments_view_affiliate_dialog: "affiliate_adjustments_view_affiliate_dialog",
  create_affiliate_adjustment: "create_affiliate_adjustment",

  // Affiliate Campaigns
  view_affiliate_campaigns_list: "view_affiliate_campaigns_list",
  export_affiliate_campaigns_list: "export_affiliate_campaigns_list",

  // ==================== Campaigns ====================
  // Campaigns
  view_campaigns_list: "view_campaigns_list",
  view_campaign_members_list: "view_campaign_members_list",
  campaigns_assign_reward: "campaigns_assign_reward",
  create_campaign: "create_campaign",
  edit_campaign: "edit_campaign",
  campaigns_view_ad_cost: "campaigns_view_ad_cost",
  campaigns_create_ad_cost: "campaigns_create_ad_cost",

  // Campaign Ad Costs
  view_ad_costs_list: "view_ad_costs_list",
  create_ad_cost: "create_ad_cost",
  edit_ad_cost: "edit_ad_cost",
  import_ad_cost: "import_ad_cost",

  // Campaign Ad Reports
  view_campaign_ad_reports: "view_campaign_ad_reports",
  export_campaign_ad_reports: "export_campaign_ad_reports",

  // Whatsapp Campaign
  view_whatsapp_campaign_list: "view_whatsapp_campaign_list",
  whatsapp_campaign_view_member_dialog: "whatsapp_campaign_view_member_dialog",
  whatsapp_campaign_edit_setting: "whatsapp_campaign_edit_setting",

  // ==================== Telemarketer ====================
  // All Leads
  view_leads_list: "view_leads_list",
  all_leads_view_member_dialog: "all_leads_view_member_dialog",
  view_remark_history: "view_remark_history",
  assign_leads: "assign_leads",
  extend_leads: "extend_leads",
  view_call_logs_attempts: "view_call_logs_attempts",
  add_remark: "add_remark",
  view_lead_justification: "view_lead_justification",
  review_lead_justification: "review_lead_justification",
  import_leads: "import_leads",
  export_all_leads_list: "export_all_leads_list",
  reassign_leads: "reassign_leads",
  undo_leads: "undo_leads",
  view_lead_history: "view_lead_history",

  // My Leads
  view_my_leads_list: "view_my_leads_list",
  call: "call",
  my_leads_view_call_logs_attempts: "my_leads_view_call_logs_attempts",
  my_leads_add_remark: "my_leads_add_remark",
  request_justification: "request_justification",
  my_leads_create_member: "my_leads_create_member",
  export_my_leads_list: "export_my_leads_list",
  my_leads_view_lead_history: "my_leads_view_lead_history",
  my_leads_assign_reward: "my_leads_assign_reward",

  // Telemarketer Report
  view_telemarketer_report: "view_telemarketer_report",
  telemarketer_report_view_deposit_details: "telemarketer_report_view_deposit_details",
  export_telemarketer_report: "export_telemarketer_report",

  // Sales Conversion Report
  view_sales_conversion_report: "view_sales_conversion_report",
  export_sales_conversion_report: "export_sales_conversion_report",

  // Lead Remarks
  view_lead_remarks: "view_lead_remarks",
  export_lead_remarks: "export_lead_remarks",

  // Telemarketing Player Summary
  view_telemarketing_player_summary: "view_telemarketing_player_summary",
  export_telemarketing_player_summary: "export_telemarketing_player_summary",

  // Telemarketer Rewards
  view_own_telemarketer_rewards_list: "view_own_telemarketer_rewards_list",
  view_all_telemarketer_rewards_list: "view_all_telemarketer_rewards_list",
  view_own_normal_account_manager_rewards_list: "view_own_normal_account_manager_rewards_list",
  view_all_normal_account_manager_rewards_list: "view_all_normal_account_manager_rewards_list",
  view_own_vip_account_manager_rewards_list: "view_own_vip_account_manager_rewards_list",
  view_all_vip_account_manager_rewards_list: "view_all_vip_account_manager_rewards_list",
  edit_telemarketer_reward: "edit_telemarketer_reward",
  telemarketer_assign_rewards: "telemarketer_assign_rewards",
  telemarketing_rewards_view_member_dialog: "telemarketing_rewards_view_member_dialog",
  telemarketing_rewards_edit_reward: "telemarketing_rewards_edit_reward",

  // Account Management
  view_own_normal_account_manager_account_management_list: "view_own_normal_account_manager_account_management_list",
  view_all_normal_account_manager_account_management_list: "view_all_normal_account_manager_account_management_list",
  view_own_vip_account_manager_account_management_list: "view_own_vip_account_manager_account_management_list",
  view_all_vip_account_manager_account_management_list: "view_all_vip_account_manager_account_management_list",
  export_account_management: "export_account_management",
  view_kpi_settings: "view_kpi_settings",
  edit_kpi_settings: "edit_kpi_settings",
  account_management_view_member_dialog: "account_management_view_member_dialog",
  account_management_edit_remark: "account_management_edit_remark",
  account_management_view_remark_history: "account_management_view_remark_history",
  view_account_manager_history: "view_account_manager_history",
  account_management_assign_leads: "account_management_assign_leads",
  account_management_assign_rewards: "account_management_assign_rewards",

  // Telemarketer Setting
  view_telemarketer_setting_list: "view_telemarketer_setting_list",
  edit_telemarketer_setting: "edit_telemarketer_setting",
  view_telemarketer_setting_log: "view_telemarketer_setting_log",
  view_affiliate_settings: "view_affiliate_settings",
  edit_affiliate_settings: "edit_affiliate_settings",
  add_affiliates: "add_affiliates",
  delete_affiliates: "delete_affiliates",

  // ==================== Events ====================
  // All Events
  view_events_list: "view_events_list",
  create_event: "create_event",
  view_event_details: "view_event_details",
  edit_event: "edit_event",
  view_team_player_settings: "view_team_player_settings",
  create_team_player: "create_team_player",
  edit_team_player: "edit_team_player",
  remove_team_player: "remove_team_player",
  update_player_display_status: "update_player_display_status",
  set_result: "set_result",

  // All Tickets
  view_tickets_list: "view_tickets_list",
  all_tickets_view_member_dialog: "all_tickets_view_member_dialog",
  export_tickets_list: "export_tickets_list",

  // All Predictions
  view_predictions_list: "view_predictions_list",
  all_predictions_view_member_dialog: "all_predictions_view_member_dialog",
  export_predictions_list: "export_predictions_list",

  // Raffle Event Details
  view_raffle_events_list: "view_raffle_events_list",
  create_raffle_event: "create_raffle_event",
  edit_raffle_event: "edit_raffle_event",
  view_raffle_event_details: "view_raffle_event_details",

  // ==================== Special Permission ====================
  // Top Navigation Bar
  clear_cache: "clear_cache",
  manual_sync: "manual_sync",
  affiliate_approvals_shortcut: "affiliate_approvals_shortcut",
  affiliate_deposit_shortcut: "affiliate_deposit_shortcut",
  affiliate_withdrawal_shortcut: "affiliate_withdrawal_shortcut",
  deposit_shortcut: "deposit_shortcut",
  withdrawal_shortcut: "withdrawal_shortcut",
  member_promotion_shortcut: "member_promotion_shortcut",
  view_own_downloads_history: "view_own_downloads_history",
  view_all_downloads_history: "view_all_downloads_history",
  view_own_import_history: "view_own_import_history",
  view_all_import_history: "view_all_import_history",
  transfer_shortcut: "transfer_shortcut",

  // Others
  panic_mode: "panic_mode",
  view_password: "view_password",
  export_crm_campaign_log: "export_crm_campaign_log",
  access_masked_member_account: "access_masked_member_account",

  // ==================== Operators ====================
  // Operators
  view_operator_2fa: "view_operator_2fa",
  reset_operator_2fa: "reset_operator_2fa",
  view_operators_list: "view_operators_list",
  create_operator: "create_operator",
  edit_operator: "edit_operator",
  edit_phone_number_access: "edit_phone_number_access",
  edit_email_access: "edit_email_access",
  reset_operator_password: "reset_operator_password",

  // Roles
  view_roles_list: "view_roles_list",
  create_role: "create_role",
  edit_role: "edit_role",

  // IP whitelisting
  view_ip_whitelist: "view_ip_whitelist",
  create_ip_whitelist: "create_ip_whitelist",
  edit_ip_whitelist: "edit_ip_whitelist",

  // Application Roles
  app_role_view_roles_list: "app_role_view_roles_list",
  app_role_create_role: "app_role_create_role",
  app_role_edit_role: "app_role_edit_role",
  app_role_duplicate_role: "app_role_duplicate_role",

  // Application Permissions
  view_permissions_list: "view_permissions_list",
  edit_permission: "edit_permission",

  // ==================== Game Providers ====================

  // All Game Providers
  view_game_providers_list: "view_game_providers_list",
  view_game_provider_details: "view_game_provider_details",
  edit_game_provider: "edit_game_provider",
  update_game_provider_status: "update_game_provider_status",
  edit_position: "edit_position",
  view_mini_games_list: "view_mini_games_list",
  edit_mini_game: "edit_mini_game",
  create_mini_game: "create_mini_game",
  export_mini_game_list: "export_mini_game_list",
  view_quick_link_setting: "view_quick_link_setting",
  edit_quick_link_setting: "edit_quick_link_setting",
  game_providers_view_gp_blacklist: "game_providers_view_gp_blacklist",
  game_providers_view_gp_blacklist_template: "game_providers_view_gp_blacklist_template",
  game_providers_add_gp_blacklist_template: "game_providers_add_gp_blacklist_template",
  game_providers_edit_gp_blacklist_template: "game_providers_edit_gp_blacklist_template",
  game_providers_duplicate_gp_blacklist_template: "game_providers_duplicate_gp_blacklist_template",

  // Game Provider Position
  view_game_provider_position: "view_game_provider_position",
  edit_game_provider_position: "edit_game_provider_position",

  // Game Tags
  view_game_tags_list: "view_game_tags_list",
  create_game_tag: "create_game_tag",
  edit_game_tag: "edit_game_tag",
  view_game_tag_details: "view_game_tag_details",
  edit_game_tag_settings: "edit_game_tag_settings",
  add_games: "add_games",
  remove_games: "remove_games",
  reset_games: "reset_games",
  sync_games: "sync_games",

  // Maintenance Hours
  view_maintenance_hours_list: "view_maintenance_hours_list",
  create_game_provider_maintenance_hour: "create_game_provider_maintenance_hour",
  edit_game_provider_maintenance_hour: "edit_game_provider_maintenance_hour",

  // ==================== Reports ====================

  // Member Report
  view_member_report: "view_member_report",
  export_member_report: "export_member_report",
  view_member_bet_logs_report: "view_member_bet_logs_report",
  view_game_result: "view_game_result",
  export_member_bet_logs_report: "export_member_bet_logs_report",

  // All Member Report
  view_all_member_report: "view_all_member_report",
  export_all_member_report: "export_all_member_report",
  all_member_report_view_member_report: "all_member_report_view_member_report",
  all_member_report_view_member_bet_logs_report: "all_member_report_view_member_bet_logs_report",
  all_member_report_view_game_result: "all_member_report_view_game_result",
  all_member_report_export_member_bet_logs_report: "all_member_report_export_member_bet_logs_report",

  // Game Provider Report
  view_game_provider_report: "view_game_provider_report",
  export_game_provider_report: "export_game_provider_report",
  view_game_provider_breakdown: "view_game_provider_breakdown",
  export_game_provider_breakdown: "export_game_provider_breakdown",
  game_provider_report_view_member_bet_logs_report: "game_provider_report_view_member_bet_logs_report",
  game_provider_report_view_game_result: "game_provider_report_view_game_result",
  game_provider_report_export_member_bet_logs_report: "game_provider_report_export_member_bet_logs_report",

  // Marketing Report
  view_marketing_report: "view_marketing_report",
  view_marketing_report_details: "view_marketing_report_details",
  export_marketing_report: "export_marketing_report",

  // Daily New Deposit Report
  view_daily_new_deposit_report: "view_daily_new_deposit_report",
  daily_new_deposit_report_view_member_dialog: "daily_new_deposit_report_view_member_dialog",
  export_daily_new_deposit_report: "export_daily_new_deposit_report",

  // Company Report
  view_company_report: "view_company_report",
  export_company_report: "export_company_report",

  // Registration Report
  view_registration_report: "view_registration_report",
  registration_report_view_member_dialog: "registration_report_view_member_dialog",
  export_registration_report: "export_registration_report",

  // SMS Recovery Report
  view_sms_recovery_report: "view_sms_recovery_report",
  view_sms_recovery_report_details: "view_sms_recovery_report_details",
  export_sms_recovery_report: "export_sms_recovery_report",

  // Marketing W/M Report
  view_marketing_w_m_report: "view_marketing_w_m_report",
  export_marketing_w_m_report: "export_marketing_w_m_report",

  // Game Type Report
  view_game_type_report: "view_game_type_report",
  export_game_type_report: "export_game_type_report",
  view_game_type_breakdown: "view_game_type_breakdown",
  export_game_type_breakdown: "export_game_type_breakdown",
  game_type_report_view_member_bet_logs_report: "game_type_report_view_member_bet_logs_report",
  game_type_report_view_game_result: "game_type_report_view_game_result",
  game_type_report_export_member_bet_logs_report: "game_type_report_export_member_bet_logs_report",

  // All Affiliates Report
  view_all_affiliates_report: "view_all_affiliates_report",
  export_all_affiliates_report: "export_all_affiliates_report",
  view_affiliate_information: "view_affiliate_information",
  view_all_affiliate_member: "view_all_affiliate_member",

  // All sub-affiliates Report
  view_all_sub_affiliates_report: "view_all_sub_affiliates_report",
  export_all_sub_affiliates_report: "export_all_sub_affiliates_report",
  view_sub_affiliate_information: "view_sub_affiliate_information",
  view_all_sub_affiliate_member: "view_all_sub_affiliate_member",

  // Affiliate FTD Report
  view_affiliate_ftd_report: "view_affiliate_ftd_report",
  export_affiliate_ftd_report: "export_affiliate_ftd_report",

  // ==================== Reports 2.0 ====================
  // Member Report 2.0
  // General
  view_all_member_report_2: "view_all_member_report_2",
  export_all_member_report_2: "export_all_member_report_2",
  view_member_report_2: "view_member_report_2",
  export_member_report_2: "export_member_report_2",
  view_member_bet_logs_report_2: "view_member_bet_logs_report_2",
  view_game_result_2: "view_game_result_2",
  export_member_bet_logs_report_2: "export_member_bet_logs_report_2",
  required_member_username_for_report_generation_general: "required_member_username_for_report_generation_general",

  // Daily
  view_daily_member_report_2_daily: "view_daily_member_report_2_daily",
  export_daily_member_report_2_daily: "export_daily_member_report_2_daily",
  view_member_report_2_daily: "view_member_report_2_daily",
  export_member_report_2_daily: "export_member_report_2_daily",
  view_member_bet_logs_report_2_daily: "view_member_bet_logs_report_2_daily",
  view_game_result_2_daily: "view_game_result_2_daily",
  export_member_bet_logs_report_2_daily: "export_member_bet_logs_report_2_daily",
  required_member_username_for_report_generation_daily: "required_member_username_for_report_generation_daily",

  // ==================== Referral Commission ====================
  // Referral Commission Release
  view_referral_commission_releases_list: "view_referral_commission_releases_list",
  referral_commission_releases_view_member_dialog: "referral_commission_releases_view_member_dialog",
  referral_commission_view_referral_commission_details: "referral_commission_view_referral_commission_details",
  generate_referral_commission: "generate_referral_commission",
  release_referral_commission: "release_referral_commission",
  reject_referral_commission: "reject_referral_commission",

  // Referral Commission Details
  referral_commission_details_view_member_dialog: "referral_commission_details_view_member_dialog",

  // Referral Commission History
  view_referral_commission_history: "view_referral_commission_history",

  // Referral Commission Settings
  view_referral_commission_settings_list: "view_referral_commission_settings_list",
  create_referral_commission_settings: "create_referral_commission_settings",
  view_referral_commission_settings: "view_referral_commission_settings",
  edit_referral_commission_settings: "edit_referral_commission_settings",
  duplicate_referral_commission_settings: "duplicate_referral_commission_settings",

  // CRM Logs
  view_crm_fasttrack_activity_log: "view_crm_fasttrack_activity_log",
  crm_fasttrack_link_reward: "crm_fasttrack_link_reward",
  view_crm_fasttrack_promotion_log: "view_crm_fasttrack_promotion_log",
  crm_fasttrack_view_member_dialog: "crm_fasttrack_view_member_dialog",
  crm_fasttrack_link_member_promo: "crm_fasttrack_link_member_promo",
  crm_fasttrack_link_member_message: "crm_fasttrack_link_member_message",
  crm_fasttrack_link_member_sms: "crm_fasttrack_link_member_sms",
  view_crm_smartico_promotion_log: "view_crm_smartico_promotion_log",
  crm_smartico_view_member_dialog: "crm_smartico_view_member_dialog",
  crm_smartico_link_member_promo: "crm_smartico_link_member_promo",
} as const;

export type AppPermissions = {
  [K in keyof typeof AppPermissionKeys]: boolean;
};
